export const formatItemIndex = (
  index: number,
  currentPage: number,
  itemsPerPage: number,
): string => {
  return ((currentPage - 1) * itemsPerPage + index + 1)
    .toString()
    .padStart(5, '0');
};
